import { inject } from '@angular/core';
import { ParseRequestsStore } from '../stores/parse-requests.store';

export const parseRequestsLoadedGuard = () => {
  const parseRequestsStore = inject(ParseRequestsStore);
  if (
    !parseRequestsStore.allLoaded() &&
    !parseRequestsStore.isLoading() &&
    !parseRequestsStore.error()
  ) {
    parseRequestsStore.load();
  }
  return true;
};
